"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const classNames = require("classnames");
const react_1 = require("react");
const DatagridCards_1 = require("./DatagridCards");
const DatagridFilters_1 = require("./DatagridFilters");
const DatagridHeader_1 = require("./DatagridHeader");
const DatagridPagination_1 = require("./DatagridPagination");
const DatagridTable_1 = require("./DatagridTable");
const models_1 = require("./models");
class Datagrid extends react_1.Component {
    constructor(props) {
        super(props);
        this.handleToggleFilters = () => {
            this.setState({ filtersActive: !this.state.filtersActive });
        };
        this.handleChangeViewMode = (viewMode) => {
            this.setState({ viewMode });
            this.props.onChangeViewMode(viewMode);
        };
        this.handleQueryChange = (queryProp) => (value) => {
            const { query, onChangeQuery } = this.props;
            const updatedQuery = Object.assign({}, query, { [queryProp]: value });
            this.props.onChangeQuery(updatedQuery);
        };
        this.state = {
            filtersActive: props.filtersActive,
            viewMode: props.viewMode,
        };
    }
    render() {
        const { loading, noDefaultFilter, noFilters, noFiltersHeader, noHeader, noPagination, noSearchBarCollapse, noSearchBy, noTotalInHeader, noViewModeButton, limitOptions, mainButton, properties, query, searchInputPlaceholder, searchPropertyOptions, searchTerm, tableMinWidth, total, onChangeSearchProperty, onResetAllFilters, onSearchTerm } = this.props;
        const { filtersActive, viewMode } = this.state;
        if (!this.props.children) {
            return null;
        }
        const children = this.getChildrenAsArray();
        const tableView = children.filter(e => e.type.displayName === 'DatagridTableView');
        const cardsView = children.filter(e => e.type.displayName === 'DatagridCardsView');
        const mapView = children.filter(e => e.type.displayName === 'DatagridMapView');
        const filters = children.filter(e => e.type.displayName === 'DatagridFiltersSlot');
        return (React.createElement("div", { className: "bkn-datagrid" },
            React.createElement("div", { className: classNames('bkn-datagrid-inner', { 'filters-active': !noFilters && filtersActive }) },
                React.createElement("div", { className: "bkn-datagrid-data-column" },
                    !noHeader && (React.createElement(DatagridHeader_1.DatagridHeader, { hideSearchByField: noSearchBy, hideToggleFilterButton: noFilters, hideViewModeButton: noViewModeButton, hideTotalInfo: noTotalInHeader, mainButton: mainButton, noSearchBarCollapse: noSearchBarCollapse, searchInputPlaceholder: searchInputPlaceholder, searchPropertyOptions: searchPropertyOptions, searchTerm: searchTerm, total: total, viewMode: viewMode, onTypeSearchTerm: onSearchTerm, onChangeSearchProperty: (e) => onChangeSearchProperty(e.target.value), onChangeViewMode: this.handleChangeViewMode, onClickToggleFiltersButton: this.handleToggleFilters })),
                    React.createElement("div", { className: classNames('progress', {
                            'progress-active': loading,
                            'no-top': noHeader,
                        }) },
                        React.createElement("div", { className: "progress-bar progress-bar-striped progress-bar-animated", role: "progressbar", "aria-valuenow": "100", "aria-valuemin": "0", "aria-valuemax": "100" })),
                    viewMode === models_1.ViewMode.table && tableView && tableView.length > 0 && (React.createElement(DatagridTable_1.DatagridTable, { properties: properties, sort: query.sort, tableMinWidth: tableMinWidth, onSort: this.handleQueryChange('sort') }, tableView)),
                    viewMode === models_1.ViewMode.cards && cardsView && cardsView.length > 0 && (React.createElement(DatagridCards_1.DatagridCards, null, cardsView)),
                    viewMode === models_1.ViewMode.map && mapView && mapView.length > 0 && (this.renderMapView(mapView)),
                    !noPagination && (React.createElement(DatagridPagination_1.DatagridPagination, { limitOptions: limitOptions, limit: query.limit, skip: query.skip, total: total, onChangeLimit: this.handleQueryChange('limit'), onChangeSkip: this.handleQueryChange('skip') }))),
                !noFilters && (React.createElement("div", { className: "bkn-datagrid-filter-column" },
                    React.createElement(DatagridFilters_1.DatagridFilters, { noHeader: noFiltersHeader, noDefaultFilter: noDefaultFilter, properties: properties, sort: query.sort, onClickClose: this.handleToggleFilters, onClickResetAll: onResetAllFilters, onSort: this.handleQueryChange('sort') }, filters))))));
    }
    renderMapView(mapView) {
        return mapView[0];
    }
    getChildrenAsArray() {
        return (this.props.children instanceof Array ? this.props.children : [this.props.children]);
    }
}
Datagrid.propTypes = {
    children: (props, propName, componentName) => {
        const children = props[propName] && (Array.isArray(props[propName])
            ? props[propName]
            : [props[propName]]);
        if (!children) {
            return;
        }
        const childrenHasNotAllowedElements = children
            .some(c => typeof c.type === 'string' ||
            (c.type.displayName !== 'DatagridTableView' &&
                c.type.displayName !== 'DatagridCardsView' &&
                c.type.displayName !== 'DatagridMapView' &&
                c.type.displayName !== 'DatagridFiltersSlot'));
        if (childrenHasNotAllowedElements) {
            console.warn('Prop `' + propName + '` supplied to `' + componentName +
                '` has invalid elements.' + ' `' + componentName +
                '` only accepts children of type `DatagridTableView`, `DatagridCardsView`, `DatagridMapView` and `DatagridFiltersSlot`.' +
                ' Others components will be ignored.');
            return;
        }
    },
};
Datagrid.defaultProps = {
    filtersActive: true,
    loading: false,
    limitOptions: [50, 100, 200],
    mainButton: undefined,
    noDefaultFilter: false,
    noFilters: false,
    noFiltersHeader: false,
    noHeader: false,
    noPagination: false,
    noSearchBarCollapse: false,
    noSearchBy: false,
    noTotalInHeader: false,
    noViewModeButton: false,
    properties: [],
    query: {
        sort: '',
        limit: 50,
        skip: 0,
    },
    searchInputPlaceholder: 'Search',
    searchPropertyOptions: [],
    searchTerm: '',
    tableMinWidth: 1400,
    total: 0,
    viewMode: models_1.ViewMode.table,
    onChangeQuery: () => { return; },
    onChangeSearchProperty: () => { return; },
    onChangeViewMode: () => { return; },
    onResetAllFilters: () => { return; },
    onSearchTerm: () => { return; },
};
exports.Datagrid = Datagrid;



//////////////////
// WEBPACK FOOTER
// ./src/components/Datagrid/Datagrid.tsx
// module id = 243
// module chunks = 0